import { render, staticRenderFns } from "./FormularioCostos.vue?vue&type=template&id=a4b58c6c&"
import script from "./FormularioCostos.vue?vue&type=script&lang=ts&"
export * from "./FormularioCostos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a4b58c6c', component.options)
    } else {
      api.reload('a4b58c6c', component.options)
    }
    module.hot.accept("./FormularioCostos.vue?vue&type=template&id=a4b58c6c&", function () {
      api.rerender('a4b58c6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/OrdenesCompra/FormularioCostos.vue"
export default component.exports